/**
 * External Dependencies
 */
import 'jquery';

import './locomotive/app';
import { BrowserMultiFormatReader, NotFoundException } from '@zxing/library';
import Swal from 'sweetalert2';

$(() => {
    const ajaxurl = '/wp/wp-admin/admin-ajax.php';
    const color_primary = '#577a53';
    const color_red = '#be453d';

    // Swal custom Classes
    // customClass: {
    //     container: 'your-container-class',
    //     popup: 'your-popup-class',
    //     header: 'your-header-class',
    //     title: 'your-title-class',
    //     closeButton: 'your-close-button-class',
    //     icon: 'your-icon-class',
    //     image: 'your-image-class',
    //     content: 'your-content-class',
    //     input: 'your-input-class',
    //     actions: 'your-actions-class',
    //     confirmButton: 'your-confirm-button-class',
    //     cancelButton: 'your-cancel-button-class',
    //     footer: 'your-footer-class'
    // }

    // Ajouter/Supprimer de la Wishlist
    $('body').on('click', '[data-action="wishlist"]', function() {
        var $this = $(this);
        var offre_id = $this.data('id');
        var data = {
            'action': 'set_wishlist',
            'offre_id': offre_id,
        };

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: data,
            success: function( response ){
                if(response.data.login) {
                    if(response.data.icon) {
                        $this.html(response.data.icon);
                    }
                    if($this.data('refresh')) {
                        window.location.reload();
                    }
                }else {
                    // $('#login-modal').modal({show:true}); // Popup avec formualre de connexion
                }
            },
        });
        return false;
    });

    // Supprimer une offre de la liste des candidatures
    $('body').on('click', '[data-action="softdelete"]', function() {
        var $this = $(this);
        var offre_id = $this.data('offreid');
        var user_id = $this.data('userid');
        var data = {
            'action': 'candidature_soft_delete',
            'offre_id': offre_id,
            'user_id': user_id,
        };

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: data,
            success: function( response ){
                if(response == 'success') {
                    location.reload();
                }
            },
        });
        return false;
    });

    // Supprimer Compte
    $('body').on('click', '[data-action="delete-account"]', function() {
        Swal.fire({
            title: 'Êtes-vous sûr(e) de vouloir supprimer votre compte ?',
            html: 'Vos informations personnelles, vos documents seront definitevement supprmés !',
            showCancelButton: true,
            confirmButtonColor: color_primary,
            cancelButtonColor: color_red,
            confirmButtonText: 'Oui, Supprimer',
            cancelButtonText: 'Annuler',
            customClass: {
                title: 'c-heading -h4',
            }
        }).then((result) => {
            if (result.value) {
                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: {'action': 'delete_account'},
                    success: function( response ){
                        if(response) {
                            Swal.fire({
                                title: 'Votre compte a été supprimé !',
                                type: 'success',
                                confirmButtonColor: color_primary,
                                confirmButtonText: 'OK',
                            }).then((result) => {
                                if (result.value) {
                                    window.location.reload();
                                }
                            });
                        }else {
                            Swal.fire({
                                title: 'Une erreur est survenue !',
                                type: 'error',
                                confirmButtonColor: color_primary,
                                confirmButtonText: 'OK',
                            }).then((result) => {
                                if (result.value) {
                                    window.location.reload();
                                }
                            });
                        }
                    },
                });
            }
        });
    });

    // Postuler avec compte
    $('body').on('click', '[data-action="postuler"]', function() {
        Swal.fire({
            title: 'Êtes-vous sûr(e) de vouloir postuler ?',
            html: '<span class="c-text">En postulant, nous enverrons votre cv, lettre de motivation et votre profil au recruteur ! <br>Vous pouvez <a href="/mon-espace/mon-compte" data-load="false" target="_blank">modifier votre compte ici</a></span>',
            showCancelButton: true,
            confirmButtonColor: color_primary,
            cancelButtonColor: color_red,
            confirmButtonText: 'Oui, Postuler',
            cancelButtonText: 'Annuler',
            customClass: {
                title: 'c-heading -h4',
            },
            showLoaderOnConfirm: true
        }).then((result) => {
            if (result.value) {
                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: {'action': 'postuler', 'offre_id': $(this).attr('data-offre')},
                    success: function( response ){
                        if(response == 'error') {
                            Swal.fire({
                                title: 'Ooops !',
                                html: '<span class="c-text">Veuillez renseigner votre CV dans votre espace documents.<br>Vous pouvez <a href="/mon-espace/mes-documents/" data-load="false" target="_blank">modifier vos documents ici</a></span>',
                                type: 'error',
                                confirmButtonColor: color_primary,
                                confirmButtonText: 'OK',
                                customClass: {
                                    title: 'c-heading -h4',
                                }
                            }).then((result) => {
                                if (result.value) {
                                    window.location.reload();
                                }
                            });
                        }else {
                            if(response) {
                                Swal.fire({
                                    title: 'Merci !',
                                    html: 'Votre candidature à été prise en compte.',
                                    type: 'success',
                                    confirmButtonColor: color_primary,
                                    confirmButtonText: 'OK',
                                    customClass: {
                                        title: 'c-heading -h4',
                                    }
                                }).then((result) => {
                                    if (result.value) {
                                        window.location.reload();
                                    }
                                });
                            }else {
                                Swal.fire({
                                    title: 'Une erreur est survenue !',
                                    html: 'Veuillez postuler de nouveau.',
                                    type: 'error',
                                    confirmButtonColor: color_primary,
                                    confirmButtonText: 'OK',
                                    customClass: {
                                        title: 'c-heading -h4',
                                    }
                                }).then((result) => {
                                    if (result.value) {
                                        window.location.reload();
                                    }
                                });
                            }
                        }
                    },
                });
            }
        });
    });

    // Trigger click
    $('body').on('click', '[data-action="triggerClick"]', function() {
        let target = $(this).attr('data-target');
        $(target).trigger('click');
    });

    // Validation Scan
    window.lastResult = null;
    function resetSelect() {
      $('#date')
        .find('option')
        .remove()
        .end()
        .append(new Option('--- Sélectionnez la date ---', ''))
        .val('');
        window.lastResult = null;
    }

    function setSelectDate() {
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'salon_dates_evenement',
                evenement: $('#evenement').val(),
            },
            success: function (response) {
                resetSelect();
                if (response.dates) {
                    $('#date_wrap').removeClass('is-hidden');
                    $('#date').show();
                    $.each(response.dates, function (index, element) {
                        $('#date').append(
                            new Option(
                                element.date_formated,
                                element.date_evenement,
                                false,
                                response.dates.length === 1
                            )
                        );
                    });
                } else {
                    $('#date_wrap').addClass('is-hidden');
                    $('#date').hide();
                }
            },
        });
    }

    if ($('#evenement').val()) {
        setSelectDate();
    }

    $('#evenement').on('change', function () {
        setSelectDate();
    });

    function resetSource() {
        $('#sourceSelect')
          .find('option')
          .remove()
          .end();
      }
  
      if (!Date.now) {
        Date.now = function now() {
          return new Date().getTime();
        };
      }
  
      var resultContainer = document.getElementById('result');
      var nbScan = document.getElementById('nb-scan');
      var recap = document.getElementById('recap');
      var countResults = 0;
      var countOk = 0;
      var countError = 0;
      var sound = document.createElement('audio');
    
      function soundSelect(src) {
        sound.src = src;
        sound.setAttribute('preload', 'auto');
        sound.setAttribute('controls', 'none');
        sound.style.display = 'none';
        document.body.appendChild(sound);
      }
      function play() {
        sound.play();
      }
  
      // eslint-disable-next-line no-unused-vars
      function pause() {
        sound.pause();
      }
  
      var canVibrate = 'vibrate' in navigator || 'mozVibrate' in navigator;
  
      if (canVibrate && !('vibrate' in navigator))
        navigator.vibrate = navigator.mozVibrate;
  
    function onScanSuccess(decodedText, decodedResult) {
        if (decodedText !== window.lastResult || 1) {
            window.lastResult = decodedText;
            if (Swal.isVisible()) {
                Swal.close();
            }
            $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                    action: 'salon_check_ticket',
                    data: decodedText,
                    evenement: $('#evenement').val(),
                    date: $('#date').val(),
                },
                success: function (response) {
                    let date = new Date();
                    if (response) {
                        $('.result_div').show();
                    }
                    countResults++;
                    if (response.success) {
                        if (
                            sound.src !=
                            '/app/themes/altemploi2019/resources/assets/sounds/Ok.mp3'
                        ) {
                            soundSelect(
                                '/app/themes/altemploi2019/resources/assets/sounds/Ok.mp3'
                            );
                        }
                        play();
                        navigator.vibrate([300, 100, 200, 50, 300]);
                        
                        countOk++;
        
                        Swal.fire({
                            title: response.titre,
                            html: response.sous_titre,
                            icon: 'success',
                            timer: 3000,
                            timerProgressBar: true,
                            confirmButtonText: 'Fermer',
                            width: '80%',
                        });
        
                        resultContainer.innerHTML += `<li><b>[${date.toLocaleString(
                        'fr-FR'
                        )}]</b> - ${response.texte}</li>`;
                    } else if (response.error) {
                        soundSelect(
                        '/app/themes/altemploi2019/resources/assets/sounds/Error.mp3'
                        );
                        play();
                        navigator.vibrate(500);
                        if (response.texte) {
                        resultContainer.innerHTML += `<li class="error"><b>[${date.toLocaleString(
                            'fr-FR'
                        )}]</b> - ${response.texte}</li>`;
                        } else {
                        resultContainer.innerHTML += `<li class="error"><b>[${date.toLocaleString(
                            'fr-FR'
                        )}]</b> - ${response.error}</li>`;
                        }
        
                        countError++;
        
                        Swal.fire({
                            title: response.error,
                            html: response.sous_titre,
                            timer: 3000,
                            timerProgressBar: true,
                            icon: 'error',
                            confirmButtonText: 'Fermer',
                            width: '80%',
                        });
                    }
                    nbScan.innerHTML = `${countResults} `;
                    recap.innerHTML = `(${countOk} ✓ / ${countError} ✗)`;
                },
            });
        }
    }

    // Optional callback for error, can be ignored.
    // eslint-disable-next-line no-unused-vars
    function onScanError(qrCodeError) {
        // This callback would be called in case of qr code scan error or setup error.
        // You can avoid this callback completely, as it can be very verbose in nature.
        soundSelect('/app/themes/altemploi2019/resources/assets/sounds/Error.mp3');
        play();
    }
  
    let selectedDeviceId;
    const codeReader = new BrowserMultiFormatReader();
    codeReader
        .listVideoInputDevices()
        .then((videoInputDevices) => {
            $('.buttons').show();
            resetSource();
            const sourceSelect = document.getElementById('sourceSelect');
            selectedDeviceId = videoInputDevices[0].deviceId;
            if (videoInputDevices.length >= 1) {
                videoInputDevices.forEach((element) => {
                    const sourceOption = document.createElement('option');
                    sourceOption.text = element.label;
                    sourceOption.value = element.deviceId;
                    sourceSelect.appendChild(sourceOption);
                });

                sourceSelect.onchange = () => {
                    selectedDeviceId = sourceSelect.value;
                };

                const sourceSelectPanel = document.getElementById(
                'sourceSelectPanel'
                );

                sourceSelectPanel.style.display = 'block';
            }

            document
                .getElementById('startButton')
                .addEventListener('click', () => {
                    document.getElementById('video').style.display = 'block';
                    document.getElementById('sourceSelectPanel').style.display =
                        'none';

                    codeReader.decodeFromVideoDevice(
                        selectedDeviceId,
                        'video',
                        (result, err) => {
                        if (result) {
                            onScanSuccess(result.text, result);
                        }
                        if (err && !(err instanceof NotFoundException)) {
                            onScanError(err);
                        }
                        }
                    );
                });

            document
                .getElementById('resetButton')
                .addEventListener('click', () => {
                    codeReader.reset();
                    document.getElementById('video').style.display = 'none';
                    resetSource();
                    if (videoInputDevices.length >= 1) {
                        videoInputDevices.forEach((element) => {
                        const sourceOption = document.createElement('option');
                        sourceOption.text = element.label;
                        sourceOption.value = element.deviceId;
                        sourceSelect.appendChild(sourceOption);
                        });

                        sourceSelect.onchange = () => {
                        selectedDeviceId = sourceSelect.value;
                        };

                        const sourceSelectPanel = document.getElementById(
                        'sourceSelectPanel'
                        );

                        sourceSelectPanel.style.display = 'block';
                    }
                });
        })
            .catch((err) => {
            console.error(err)
        });
});
